<template>
  <div
    class="wrap-search-empty bg-white d-flex flex-column align-items-center"
    :class="hasBorder ? 'border' : ''"
  >
    <img
      src="../../assets/img/empty-icon.png"
      class="img-fluid d-block"
      width="70"
      alt=""
    />
    <span class="empty-content mt-6 text-gray600">{{ $t(emptyText) }}</span>
  </div>
</template>

<script>
export default {
  props: {
    emptyText: {
      type: String,
      default: '目前沒有內容',
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-search-empty {
  padding: 60px;
  border-radius: 24px;
  &.border {
    border: 1px solid $gray-200;
  }
}
</style>
